<template>
  <div class="rows">
    <div class="infinite">
      <div v-for="(batch, $index) in batchesByType" :key="`batch${$index}`">
        <div class="date">created/updated {{ getMostRecentDate(batch) }} and earlier</div>
        <div v-for="(row, $index) in batch" :key="`row${$index}`" class="row">
          <cell v-for="(col, $index) in row" :item="col" :key="$index" @on-suggest="suggest" @on-blacklist="blacklist"></cell>
        </div>
      </div>
      <infinite-loading @infinite="handleInfinite" :distance="200"></infinite-loading>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rows {
  flex: 1 1 auto;
  display: flex;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  height: 100%;
}

.infinite {
  overflow-y: scroll;
  width: 100%;
  padding: 0 20px;
}

.row {
  display: flex;
  flex: 0 0 auto;

  & > div {
    flex: 1 1 auto;
    border: 1px solid #EFF2F7;
    margin-top: 10px;
    width: 20%;

    text-align: center;
    overflow: hidden;

    & + div {
      margin-left: 10px;
    }

    & > div {
      font-size: 0.8em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.date {
  margin-top: 10px;
  background: #EFF2F7;
  font-size: 0.8em;
  padding: 3px 12px;
  color: #333;
}

</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import max from 'lodash/max'
import flatMap from 'lodash/flatMap'
import moment from 'moment'

import InfiniteLoading from 'vue-infinite-loading'
import Cell from './Cell'

export default {
  components: {
    InfiniteLoading,
    Cell
  },

  computed: {
    ...mapGetters('suggestions', {
      isFetching: 'isFetching',
      batchesByType: 'batchesByType'
    })
  },

  methods: {
    async handleInfinite ($state) {
      // console.log('handleInfinite')
      if (!this.isFetching) {
        const { empty } = await this.fetchGeodata()
        empty ? $state.complete() : $state.loaded()
      }
    },
    getMostRecentDate (batch) {
      const ctime = max(flatMap(batch[0], 'ctime'))
      return moment(ctime).fromNow()
    },
    ...mapActions('suggestions', ['fetchGeodata', 'resetGeodata', 'suggest', 'blacklist'])
  },

  created () {
    this.resetGeodata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/suggestions/Rows.vue